import React from "react";


import { Input,Select,Button, Table, message, Popconfirm, Modal, Form } from "antd";


import { SearchOutlined, BorderLeftOutlined} from '@ant-design/icons';
import { Uploadhh } from "@/components/upload/upload";
// import './BlankingList.less';

const {Option} =  Select;

const imgUrl = process.env.REACT_APP_IMG_URL;

export default class  PartyActive extends React.Component {
  FormSbmitRef = null;
    columns = [
      {
        title: "准浇编号",
        dataIndex: 'pouringNo',
        align: 'center',
      },

        {
          title: '水泥',
          dataIndex: 'cement',
          align: 'center'
        },
        {
            title: '掺和料',
            dataIndex: 'admixture',
            align: 'center'
         },
        {
          title: '细骨料',
          dataIndex: 'fineAggregate',
          align: 'center'
        },
        {
          title: '粗骨料1',
          dataIndex: 'theAggregate1',
          align: 'center'  
        },
       
     
        {
          title: '粗骨料2',
          dataIndex: 'theAggregate2',
          align: 'center',
        },

        {
            title: '外加剂1',
            dataIndex: 'admixtures1',
            align: 'center',
          },
        {
            title: '外加剂2',
            dataIndex: 'admixtures2',
            align: 'center',
        },
        {
            title: '水',
            dataIndex: 'water',
            align: 'center',
        },
        {
            title: '水胶比（W/B）',
            dataIndex: 'waterCementRatio',
            align: 'center',
        },
        {
            title: '操作',
            dataIndex: 'remark',
            align: 'center',
            width: '160px',
            render:(_,item) => {
                return (
                    <div style={{display: 'flex', justifyContent: 'center'}}>
                        <p onClick={this.toEdit.bind(this, item)} style={{color: '#6A9BF4 ', cursor:'pointer', marginRight: 20}}>编辑</p>

                        <Popconfirm
                            title="是否确认删除?"
                            onConfirm={this.toDel.bind(this, item.id)}
                            okText="Yes"
                            cancelText="No"
                        >
                          <p style={{color: '#ff0000 ', cursor:'pointer',}}>删除</p>
                        </Popconfirm>
                    </div>
                    
                    
                )
            }
        },
      ]


  state = {
    herfEarth: '',
    pagination: {
      current: 1,
      pageSize: 10,
      total: 200,
      onShowSizeChange: function(current, pageSize) {
          this.state.pagination.pageSize = pageSize;
          this.handleTableChange(this.state.pagination)
      }.bind(this),
      onChange: function(current) {
          this.state.pagination.current = current
          this.handleTableChange(this.state.pagination)
      }.bind(this),
      showTotal: function () {  //设置显示一共几条数据
          return '共 ' + this.state.pagination.total + ' 条'; 
      }.bind(this),
      showQuickJumper: true,
      },
    loading: false,

    tableData: [
        
    ],
    TableParams: {
        lengthLimit: 10,
        offsetLimit: 0,
        logic: 1,
        meStatus: '',
        pouringNo: '',
        taskStatus: '',
    },

    infoMsg: {
      signIn: [],
      singUp: []
    }, // 详情信息
    isModalVisible: false,
    addItem: {
      id: '',
      pouringNo: null,
      cement: 0,
      admixture: 0,
      fineAggregate: 0,
      theAggregate1: 0,
      theAggregate2: 0,
      admixtures1: 0,
      admixtures2: 0,
      water: 0,
      waterCementRatio: 0,
    }
  }




  componentDidMount() {
    this.getTableData()
    
  }

  getTableData(type) {
       if(type) {
           this.state.TableParams.offsetLimit = 0
           this.state.pagination.current = 1
       }
       this.setState({
           loading: true
       })  

       let projectId =  React.$getStorage('projectInfo').id
      React.$axios.post('openPositions/listTheoreticalMixRatio', {...this.state.TableParams, ...{projectId}}).then(res => {
        
        console.log(res);
        this.state.pagination.total = res.data.countList

        this.setState({
            tableData: res.data.list,
            pagination: this.state.pagination,
            loading: false
        })
      })
  }


  serchCar(name, {target:{value}}) {
    console.log(name)
    this.state.TableParams.pouringNo = value
  }

  toSerch2() {
    this.getTableData(true)
  }

  onFinishItem(val) {
    React.$axios.post('openPositions/saveTheoreticalMixRatio', { ...this.state.addItem, ...val}).then(res => {
      if(res.code === 20000) {
        this.toSerch2()
        this.setState({
          isModalVisible: false
      })
      }
    })
  }

  clierFormSbmitRef() {
    if(this.FormSbmitRef) {
      this.FormSbmitRef.resetFields()
    } else {
      setTimeout(() => {
        this.FormSbmitRef.resetFields()
      }, 500)
    }
  }


  addOneItem() {
    this.setState({
      isModalVisible: true
  })

  this.state.addItem = {
      id: '',
      pouringNo: null,
      cement: 0,
      admixture: 0,
      fineAggregate: 0,
      theAggregate1: 0,
      theAggregate2: 0,
      admixtures1: 0,
      admixtures2: 0,
      water: 0,
      waterCementRatio: 0,
  }
   

    let time = setTimeout(() => {
      clearTimeout(time)
      this.clierFormSbmitRef()  
    }, 200)

  }



  toDel(id) {
    React.$axios.post('openPositions/saveTheoreticalMixRatio', {id, del: 2}).then(res => {
        if(res.code == 20000) {
            message.success('删除成功')
            this.getTableData()
        } else {
            message.error('删除失败')
        }
    })
  }

  handleOk() {
    this.FormSbmitRef.submit()
  }

  handleCancel() {
    this.setState({
        isModalVisible: false
    })
  }

  // 点击上传
  handleClick(e) {
   
    this.toSerch2()
  }

  toEdit(item) {
  this.setState({
      isModalVisible: true
  })

  this.state.addItem =  {
      id: item.id,
      pouringNo: item.pouringNo,
      cement: item.cement,
      admixture: item.admixture,
      fineAggregate: item.fineAggregate,
      theAggregate1: item.theAggregate1,
      theAggregate2: item.theAggregate2,
      admixtures1: item.admixtures1,
      admixtures2: item.admixtures2,
      water: item.water,
      waterCementRatio: item.waterCementRatio,
    }

    let time = setTimeout(() => {
      clearTimeout(time)
      this.clierFormSbmitRef()  
    }, 200)
  }

 
  handleTableChange(value) {
    this.state.pagination = value
    this.state.TableParams.offsetLimit = (value.current-1) * value.pageSize;
    this.state.TableParams.lengthLimit = value.pageSize;
    
    this.getTableData()
  }


  onChangeT(name, value) {
    this.state.TableParams[name] = value;
    this.setState({
      TableParams: this.state.TableParams
    })
  }

  render() {
    return (
      <div className="PartyActive">
          <div className="input" style={{position: 'relative'}}>
                    <ul className={this.state.openStatus?'addOpen':'removeOpen'}>
                        <li><span>准浇证号:</span> 
                        <Input onChange={this.serchCar.bind(this, 'pouringNo')}  style={{ width: 200, height:30, marginRight:20,  }} placeholder="模糊搜索" />
                        
                        </li>
        
                            <Button  className="btn" onClick={this.toSerch2.bind(this)}>
                                <SearchOutlined  className="icon"/>
                            </Button>
                    </ul>

                    <div style={{position: 'absolute', right: 10, top: 24}}>

                        <Button type="primary" style={{marginRight: 20}} onClick={this.addOneItem.bind(this)}>
                            新增
                        </Button>

                        <Button type="primary" style={{marginRight: 20}}>
                            导入
                            <div style={{position: 'absolute', right: 0, top: 0, width: '100%', opacity: 0}}>
                            <Uploadhh  path = "openPositions/importTheoreticalMixRatio" handleClick={this.handleClick.bind(this)}  name="file" data={{}}  width={'100%'} height={'100%'} />
                            </div>
                        </Button>

                        <Button className="bt"  type="primary" icon={<BorderLeftOutlined />}>
                            <a href="https://project.1wx.cn/static/excel/import/开仓证理论配合比导入模板.xlsx" download>下载模板</a>
                        </Button>
                    </div>
                    
                </div>

                <div className="table2">
                {/* <div class="allBtn">
                   
                    <Button  className="bt" type="primary" icon={<UploadOutlined />}>
                        导入
                    </Button>
                    <Button  className="bt" type="primary" icon={<UploadOutlined className="translate" />}>
                        导出
                    </Button>
                    <Button  className="bt" type="primary" icon={<PlusOutlined />}>
                        新建
                    </Button>
                    </div> */}


                    <Table  align="center" bordered rowClassName="editable-row" pagination={this.state.pagination}
                   
                    loading={this.state.loading} rowKey={record => record.id} columns={this.columns} dataSource={this.state.tableData}  />
                </div>


                <Modal
                    title={this.state.addItem.id?'编辑':'添加'}
                    visible={this.state.isModalVisible}
                    onOk={this.handleOk.bind(this)}
                    width="800px"
                    onCancel={this.handleCancel.bind(this)}
                    >
                    
                    <Form
                        name="名称"
                        labelCol={{ span: 6 }}
                        ref={(el) => this.FormSbmitRef = el}
                        initialValues={this.state.addItem}
                        onFinish={this.onFinishItem.bind(this)}
                        >

                        <div className="ul" style={{display: 'flex'}}>

                        <div class="li" style={{width: '49%'}}>
                            <Form.Item
                                label="准浇证编号"
                                name="pouringNo"
                                rules={[{ required: true, message: '请输入准浇证编号' }]}
                            >
                                <Input />
                            </Form.Item>

                            <Form.Item
                                label="水泥"
                                name="cement"
                            >
                                <Input />
                            </Form.Item>

                            <Form.Item
                                label="掺和料"
                                name="admixture"
                            >
                                <Input />
                            </Form.Item>

                            <Form.Item
                                label="水"
                                name="water"
                            >
                                <Input />
                            </Form.Item>


                            <Form.Item
                                label="水胶比（W/B）"
                                name="waterCementRatio"
                            >
                                <Input />
                            </Form.Item>

                        </div>


                        <div className="li" style={{width: '49%'}}>
                            <Form.Item
                                    label="细骨料"
                                    name="fineAggregate"
                                >
                                    <Input />
                                </Form.Item>

                                <Form.Item
                                    label="粗骨料1"
                                    name="theAggregate1"
                                >
                                    <Input />
                                </Form.Item>

                                <Form.Item
                                    label="粗骨料2"
                                    name="theAggregate2"
                                >
                                    <Input />
                                </Form.Item>

                                <Form.Item
                                    label="外加剂1"
                                    name="admixtures1"
                                >
                                    <Input />
                                </Form.Item>

                                <Form.Item
                                    label="外加剂2"
                                    name="admixtures2"
                                >
                                    <Input />
                                </Form.Item>
                        </div>
                      </div>

                        

 


                        {/* <Form.Item
                            label="目录说明"
                            name="remark"
                        >
                            <Input />
                        </Form.Item> */}

                    </Form> 


                </Modal>


                                                                                            
      </div>
    );
  }
}
